<template>
    <div>
        <div class="navigation-container">
            <div class="inner-container">
                <div class="left-container">
                    <v-app-bar-nav-icon color="white" class="mobile-only" @click.stop="drawer = !drawer" />
                    <div class="title">Campaign Manager</div>
                    <v-layout class="desktop-only" justify-space-between row fill-height>

                        <v-menu
                            v-if="hasCampaignPrivilege"
                            :offset-y="true"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    class="dropdown-button"
                                    text
                                    color="white"
                                    v-bind="attrs"
                                    height="50px"
                                    v-on="on"
                                > Campaigns <v-icon right dark size="x-small">mdi-triangle-down</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-item v-if="hasViberCampaignPrivilege" link to="/viber">
                                    <v-btn class="desktop-only dropdown-link dropdown-button">
                                        Viber Campaigns
                                    </v-btn>
                                </v-list-item>

                                <v-list-item v-if="hasSMSCampaignPrivilege" link to="/sms">
                                    <v-btn class="desktop-only dropdown-link dropdown-button">
                                        SMS Campaigns
                                    </v-btn>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                        <v-menu
                            v-if="hasRecurringCampaignPrivilege"
                            :offset-y="true"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    class="dropdown-button"
                                    text
                                    color="white"
                                    v-bind="attrs"
                                    height="50px"
                                    v-on="on"
                                > Recurring Campaigns <v-icon right dark size="x-small">mdi-triangle-down</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-item v-if="hasRecurringViberCampaignPrivilege" link to="/recurring-viber">
                                    <v-btn class="desktop-only dropdown-link dropdown-button">
                                        Viber Campaigns
                                    </v-btn>
                                </v-list-item>

                                <v-list-item v-if="hasRecurringSMSCampaignPrivilege" link to="/recurring-sms">
                                    <v-btn class="desktop-only dropdown-link dropdown-button">
                                        SMS Campaigns
                                    </v-btn>
                                </v-list-item>
                            </v-list>
                        </v-menu>

                    </v-layout>
                    <div v-if="hasTransactionalViberPrivilege">
                        <router-link class="desktop-only simple-link" to="/transactional-viber">Transactional Viber</router-link>
                    </div>
                    <div v-if="hasTransactionalSMSPrivilege">
                        <router-link class="desktop-only simple-link" to="/transactional-sms">Transactional SMS</router-link>
                    </div>
                    <div v-if="hasTestListPrivilege">
                        <router-link class="desktop-only simple-link" to="/test-list">Test List</router-link>
                    </div>
                    <div>
                        <router-link class="desktop-only simple-link" to="/active-hours">Active Hours</router-link>
                    </div>
                    <div v-if="isAdmin">
                        <router-link class="desktop-only simple-link" to="/users">Users</router-link>
                    </div>
                    <div v-if="isAdmin">
                        <router-link class="desktop-only simple-link" to="/errors">Errors</router-link>
                    </div>
                </div>
                <div class="right-container">
                    <router-link v-if="getCurrentUser" to="/viber">
                        <div class="user-text">
                            <v-icon color="white">mdi-account</v-icon> {{ getCurrentUser.username }}
                        </div>
                    </router-link>
                    <!--                    <a-->
                    <!--                        class="simple-link"-->
                    <!--                        href="https://fbcm.mpass.ltd/assets/help.pdf"-->
                    <!--                        target="_blank"-->
                    <!--                    >-->
                    <!--                        <div-->
                    <!--                            class="right-btns"-->
                    <!--                        >-->
                    <!--                            <v-icon-->
                    <!--                                class="inline-icon"-->
                    <!--                                color="white"-->
                    <!--                                left-->
                    <!--                                dark-->
                    <!--                            >-->
                    <!--                                mdi-information-slab-circle-outline-->
                    <!--                            </v-icon>-->
                    <!--                            <span class="desktop-only">Help</span>-->
                    <!--                        </div>-->
                    <!--                    </a>-->
                    <div
                        class="right-btns"
                        @click="logOut"
                    >
                        <v-icon
                            class="inline-icon"
                            color="red"
                            left
                            dark
                        >
                            mdi-power
                        </v-icon>
                        <span style="color: red;" class="desktop-only">Sign Out</span>
                    </div>
                </div>
            </div>
        </div>
        <v-navigation-drawer
            v-if="drawer"
            v-model="drawer"
            absolute
            temporary
            height="100vh"
        >
            <h2 style="margin: 1rem;">Menu</h2>
            <v-list
                nav
                dense
            >
                <v-list-item-group
                    class="mobile-nav-container"
                    active-class="deep-purple--text text--accent-4"
                >

                    <v-list-item v-if="hasViberCampaignPrivilege" link class="mobile-link">
                        <router-link to="/viber">Viber Campaigns</router-link>
                    </v-list-item>

                    <v-list-item v-if="hasSMSCampaignPrivilege" link class="mobile-link">
                        <router-link to="/sms">SMS Campaigns</router-link>
                    </v-list-item>

                    <v-list-item v-if="hasRecurringViberCampaignPrivilege" link class="mobile-link">
                        <router-link to="/recurring-viber">Recurring Viber Campaigns</router-link>
                    </v-list-item>

                    <v-list-item v-if="hasRecurringSMSCampaignPrivilege" link class="mobile-link">
                        <router-link to="/recurring-sms">Recurring SMS Campaigns</router-link>
                    </v-list-item>

                    <v-list-item v-if="hasTransactionalViberPrivilege" class="mobile-link">
                        <router-link to="/transactional-viber">Transactional Viber</router-link>
                    </v-list-item>

                    <v-list-item v-if="hasTransactionalSMSPrivilege" class="mobile-link">
                        <router-link to="/transactional-sms">Transactional SMS</router-link>
                    </v-list-item>

                    <v-list-item v-if="hasTestListPrivilege" class="mobile-link">
                        <router-link to="/test-list">Test List</router-link>
                    </v-list-item>

                    <v-list-item v-if="isAdmin" class="mobile-link">
                        <router-link to="/users">Users</router-link>
                    </v-list-item>

                    <v-list-item class="mobile-link">
                        <router-link to="/active-hours">Active Hours</router-link>
                    </v-list-item>
                    <v-list-item class="mobile-link">
                        <router-link to="/errors">Errors</router-link>
                    </v-list-item>
                </v-list-item-group>
            </v-list>
        </v-navigation-drawer>
    </div>
</template>

<script>
    import { PRIVILEGES } from '@/utils/consts'
    import { hasPrivilege } from '@/utils/userUtils'
    export default {
        name: 'NavigationBar',
        data() {
            return {
                drawer: false
            }
        },
        computed: {
            getCurrentUser() {
                return this.$store.getters.getCurrentUser
            },
            isAdmin() {
                return this.$store.getters.isCurrentUserAdmin
            },
            hasViberCampaignPrivilege() {
                return hasPrivilege(
                    PRIVILEGES.VIBER_CAMPAIGN_READ_PRIVILEGE,
                    this.$store.getters.getCurrentUserPrivileges
                )
            },
            hasTestListPrivilege() {
                return hasPrivilege(
                    PRIVILEGES.TESTLIST_READ_PRIVILEGE,
                    this.$store.getters.getCurrentUserPrivileges
                )
            },
            hasSMSCampaignPrivilege() {
                return hasPrivilege(
                    PRIVILEGES.SMS_CAMPAIGN_READ_PRIVILEGE,
                    this.$store.getters.getCurrentUserPrivileges
                )
            },
            hasCampaignPrivilege() {
                return this.hasSMSCampaignPrivilege || this.hasViberCampaignPrivilege
            },
            hasRecurringViberCampaignPrivilege() {
                return hasPrivilege(
                    PRIVILEGES.RECURRING_VIBER_CAMPAIGN_READ_PRIVILEGE,
                    this.$store.getters.getCurrentUserPrivileges
                )
            },
            hasRecurringSMSCampaignPrivilege() {
                return hasPrivilege(
                    PRIVILEGES.RECURRING_SMS_CAMPAIGN_READ_PRIVILEGE,
                    this.$store.getters.getCurrentUserPrivileges
                )
            },
            hasRecurringCampaignPrivilege() {
                return this.hasRecurringViberCampaignPrivilege || this.hasRecurringSMSCampaignPrivilege
            },
            hasTransactionalViberPrivilege() {
                return hasPrivilege(
                    PRIVILEGES.TRANSACTIONAL_VIBER_READ_PRIVILEGE,
                    this.$store.getters.getCurrentUserPrivileges
                )
            },
            hasTransactionalSMSPrivilege() {
                return hasPrivilege(
                    PRIVILEGES.TRANSACTIONAL_SMS_READ_PRIVILEGE,
                    this.$store.getters.getCurrentUserPrivileges
                )
            }
        },
        methods: {
            logOut() {
                this.$store.dispatch('logout')
                this.$router.push('/login')
            },
            matchesPath(path) {
                return this.$route.path === path
            }
        }
    }
</script>

<style>
    .navigation-container {
        background: #3c8dbc;
        width: 100%;
        font-size: 1rem;
        position: absolute;
        height: 100%;
        font-weight: 400;
        color: white;
        left: 0;
        top: 0;
        z-index: 5;
    }

    .user-text {
        text-decoration: none;
        color: white;
        padding: 5px;
        transition: box-shadow 1s;
        border-radius: 12px;
    }

    .user-text:hover {
        box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.5);
    }

    .list-title {
        width: 160px;
        color: white !important;
    }

    .simple-link {
        text-decoration: none;
        letter-spacing: 0.0892857143em;
        text-indent: 0.0892857143em;
        color: white !important;
    }

    .dropdown-button {
        text-transform: none !important;
        font-family: Roboto, sans-serif !important;
        font-size: 1rem !important;
    }

    .dropdown-link {
        text-decoration: none;
        color: black !important;
    }

    title {
        font-weight: bold;
    }

    .right-btns {
        cursor: pointer;
    }

    .inline-icon {
        vertical-align: bottom;
        font-size: 18px !important;
    }

    .left-container {
        display: flex;
        justify-content: space-evenly;
        column-gap: 15px;
        align-items: center;

        div:has(> .router-link-active) {
            border-radius: 4px;
            padding: 0.3rem;
            background-color: rgba(255, 255, 255, 0.2);
        }
    }

    .menuable__content__active {
        .v-list-item--active .v-btn {
            font-weight: 900;
        }

        .v-list-item--active::before {
            opacity: 0.3 !important;
        }

        .simple-link:hover {
            font-weight: 900;
            text-decoration: underline !important;
        }
    }

    .right-container {
        display: flex;
        justify-content: space-evenly;
        column-gap: 15px;
        align-items: center;
    }

    .inner-container {
        margin: 10px;
        display: flex;
        justify-content: space-between;
        height: 50px;
    }

    @media screen and (max-width: 992px) {
        .v-overlay {
            height: 100vh;
        }

        .left-container {
            column-gap: 0;
        }

        .title {
            font-size: 12px !important;
            letter-spacing: 1px;
        }

        .mobile-link a {
            text-decoration: none;
            color: #000 !important;
            font-size: 0.9rem !important;
            width: 100%;
        }

        .mobile-link a.router-link-active {
            text-decoration: underline;
            font-size: 1rem !important;
        }
    }

</style>
